import React from 'react';
import s from './chat-list.module.scss';
import { useShallow } from 'zustand/react/shallow';
import { useProfile } from '@shared/api/useProfile';
import { useChatList } from '../model/use-chat-list';
import { useChatStore } from '@entities/messanger';
import { ChatListSkeleton } from './chat-list-skeleton';
import { ChatCard } from './chat-card';

export const ChatList = ({ chats: chatsProp, query = '' }) => {
  const { chats: storeChats, selectedChat, handleSelectChat } = useChatList();
  const chats = chatsProp ?? storeChats;
  const { data: profile } = useProfile();
  const { chatsLoading, wsConnected } = useChatStore(
    useShallow((state) => ({ chatsLoading: state.chatsLoading, wsConnected: state.wsConnected }))
  );

  if (chatsLoading && chats.length === 0) {
    return (
      <div className={s.chatListWrapper}>
        <div className={s.chatScroller}>
          <ChatListSkeleton />
        </div>
      </div>
    );
  }

  if (chats.length === 0) {
    return (
      <div className={s.chatListWrapper}>
        <div className={s.emptyState}>
          {query ? (
            <span>Ничего не найдено</span>
          ) : wsConnected ? (
            <span>У вас пока нет чатов</span>
          ) : (
            <span>Загрузка чатов…</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className={s.chatListWrapper}>
      <div className={s.chatScroller}>
        <div className={s.chatsList}>
          {chats.map((chat) => (
            <ChatCard
              key={chat?.id}
              chat={chat}
              isActive={selectedChat?.id === chat?.id}
              profileId={profile?.id}
              onClick={() => handleSelectChat(chat)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
